import React from 'react';
import './ActionButton.css';

function ActionButton({ text, onClick, bgColor, textColor, hoverBgColor, hoverTextColor }) {
  return (
    <button
      className="action-button"
      onClick={onClick}
      style={{
        '--bg-color': bgColor || '#74C0FC',
        '--text-color': textColor || 'white',
        '--hover-bg-color': hoverBgColor || '#5a9bd8',
        '--hover-text-color': hoverTextColor || 'white',
      }}
    >
      {text}
    </button>
  );
}

export default ActionButton;
